module.exports = __webpack_public_path__ + "static/k_mrgk-05d3bfc299e72bcaf57d823f6ca6f559.jpg";